import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { Http} from '@angular/http';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { CustomerStatementEndpoint } from '@app/services/customerStatement/customerStatement-endpoint.service';

@Injectable()
export class CustomerStatementService {
    constructor(private router: Router, private http: Http, private customerstatementEndpoint: CustomerStatementEndpoint) {
    }
    getCustomerStatement(CustomerId:number) {
    return this.customerstatementEndpoint.getCustomerStatement(CustomerId);
  }

  getBillPurchaseAndPaymentSummary(CustomerId:number) {
    return this.customerstatementEndpoint.getBillPurchaseAndPaymentSummary(CustomerId);
  }
} 


// WEBPACK FOOTER //
// ./src/app/services/customerStatement/customerStatement.service.ts